import { importAll } from 'helpers/import_all'
const context = require.context('.', true, /\.js$/)
importAll(context)
